import { useWatch } from 'react-hook-form';

import { useNumberOfGuests } from 'reservations/booking/providers/BookingProvider';

export function useIsValidPartySize() {
  const numberOfGuests = useNumberOfGuests();
  const partySize = useWatch({ name: 'partySize' });

  return numberOfGuests <= partySize;
}
